import React from "react";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";
import CurrentUser from "../queries/CurrentUser";

const RequireAdmin = (WrappedComponent) => {
  const AuthenticatedComponent = (props) => {
    const { loading, error, data } = useQuery(CurrentUser);

    if (loading) return null;
    if (error) {
      console.log("error:");
      console.log(error);
      return <p>Something Went Wrong...</p>;
    }
    const path = window.location.pathname;

    const isReportRoute = path.startsWith("/admin/reports");

    if (typeof data.currentUser === "undefined" || data.currentUser === null) {
      console.log("navigating to login, no current user found.");
      return <Navigate to="/login" replace={true} />;
    }

    if (
      data.currentUser.role !== "admin" &&
      !(data.currentUser.role === "report_viewer" && isReportRoute)
    ) {
      return <Navigate to="/dashboard" replace={true} />;
    } else {
      console.log("navigating to dashboard, current user is an admin.");
      return <WrappedComponent currentUser={data.currentUser} />;
    }
  };

  return <AuthenticatedComponent />;
};

export default RequireAdmin;
